'use strict';

angular.module('uniromaLandingApp')
    .factory('RejectedRow', ['$resource', 'DateUtils',function ($resource, DateUtils) {
        return $resource('api/rejectedRows/:id', {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'prev': {
                method: 'GET',
                url: 'api/prevRejectedRows/:id',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'next': {
                method: 'GET',
                url: 'api/nextRejectedRows/:id',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }])
    .factory('RejectedRowFilter', ['$resource','DateUtils',function ($resource, DateUtils) {
	    return $resource('api/rejectedRows/idJobList', {}, {
	        'query': { method: 'GET', isArray: true}
	    });
	}]);
